import React, { useState } from 'react';
import { Card } from './ui/Card';
import { Badge } from './ui/Badge';
import { Button } from './ui/Button';
import { CalendarIcon, CheckIcon, XIcon, ExternalLinkIcon, LockIcon, SparklesIcon } from 'lucide-react';
import { useEvent } from '../contexts/EventContext';
import { whatsOnEvents, WhatsOnEvent } from '../data/whatsOn';
export function WhatsOn() {
  const {
    currentEvent
  } = useEvent();
  // Filter events by current event
  const [events, setEvents] = useState<WhatsOnEvent[]>(whatsOnEvents.filter(e => e.eventId === currentEvent.id));
  const handleRSVP = (eventId: string, status: 'accepted' | 'declined') => {
    setEvents(events.map(e => e.id === eventId ? {
      ...e,
      rsvpStatus: status
    } : e));
  };
  const handleExternalLink = (url: string) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };
  const getTextColor = () => {
    if (currentEvent.id === 'active') {
      return '#17313a';
    }
    return 'white';
  };
  return <div className="pb-24" data-id="element-4229">
      {/* Events List */}
      <div className="px-4 py-4 space-y-4" data-id="element-4230">
        {events.length === 0 ? <div className="text-center py-12" data-id="element-4231">
            <CalendarIcon className="w-16 h-16 mx-auto mb-4 text-gray-300" data-id="element-4232" />
            <h3 className="text-lg font-bold text-gray-900 font-gotham mb-2" data-id="element-4233">
              No Special Events
            </h3>
            <p className="text-gray-600 font-gotham" data-id="element-4234">
              Check back later for exclusive events and experiences
            </p>
          </div> : events.map(event => <Card key={event.id} padding="none" className="overflow-hidden" data-id="element-4235">
              {/* Event Image */}
              {event.imageUrl && <div className="relative w-full h-48 bg-gray-100" data-id="element-4236">
                  <img src={event.imageUrl} alt={event.title} className="w-full h-full object-cover" data-id="element-4237" />
                  {event.inviteOnly && <div className="absolute top-3 right-3" data-id="element-4238">
                      <Badge variant="default" size="sm" className="bg-black bg-opacity-70 text-white border-0" data-id="element-4239">
                        <LockIcon className="w-3 h-3 mr-1 inline" data-id="element-4240" />
                        Invite Only
                      </Badge>
                    </div>}
                </div>}

              <div className="p-4" data-id="element-4241">
                {/* Title and Date */}
                <div className="mb-3" data-id="element-4242">
                  <div className="flex items-start justify-between gap-2 mb-2" data-id="element-4243">
                    <h3 className="text-lg font-bold text-gray-900 font-gotham" data-id="element-4244">
                      {event.title}
                    </h3>
                    {!event.imageUrl && event.inviteOnly && <Badge variant="default" size="sm" data-id="element-4245">
                        <LockIcon className="w-3 h-3 mr-1 inline" data-id="element-4246" />
                        Invite Only
                      </Badge>}
                  </div>
                  <div className="flex items-center gap-2 text-sm font-semibold font-gotham" style={{
              color: currentEvent.id === 'active' ? currentEvent.colors.secondary : currentEvent.colors.primary
            }} data-id="element-4247">
                    <CalendarIcon className="w-4 h-4" data-id="element-4248" />
                    {event.date}
                  </div>
                </div>

                {/* Description */}
                <p className="text-sm text-gray-700 font-gotham mb-4 leading-relaxed" data-id="element-4249">
                  {event.description}
                </p>

                {/* RSVP Actions */}
                {event.rsvpRequired && <div className="space-y-2" data-id="element-4250">
                    {event.rsvpStatus === 'pending' && <div className="flex gap-2" data-id="element-4251">
                        <Button variant="primary" fullWidth onClick={() => handleRSVP(event.id, 'accepted')} data-id="element-4252">
                          <CheckIcon className="w-4 h-4 mr-1 inline" data-id="element-4253" />
                          Accept Invitation
                        </Button>
                        <Button variant="outline" fullWidth onClick={() => handleRSVP(event.id, 'declined')} data-id="element-4254">
                          <XIcon className="w-4 h-4 mr-1 inline" data-id="element-4255" />
                          Decline
                        </Button>
                      </div>}
                    {event.rsvpStatus === 'accepted' && <div className="flex items-center justify-center gap-2 p-3 rounded-lg" style={{
              backgroundColor: `${currentEvent.colors.primary}10`,
              color: currentEvent.colors.primary
            }} data-id="element-4256">
                        <CheckIcon className="w-5 h-5" data-id="element-4257" />
                        <span className="font-semibold font-gotham" data-id="element-4258">
                          You're attending this event
                        </span>
                      </div>}
                    {event.rsvpStatus === 'declined' && <div className="flex items-center justify-center gap-2 p-3 rounded-lg bg-gray-100 text-gray-600" data-id="element-4259">
                        <XIcon className="w-5 h-5" data-id="element-4260" />
                        <span className="font-semibold font-gotham" data-id="element-4261">
                          You declined this invitation
                        </span>
                      </div>}
                  </div>}

                {/* External CTA */}
                {event.ctaLabel && event.ctaUrl && <Button variant="outline" fullWidth onClick={() => handleExternalLink(event.ctaUrl!)} data-id="element-4262">
                    {event.ctaLabel}
                    <ExternalLinkIcon className="w-4 h-4 ml-1 inline" data-id="element-4263" />
                  </Button>}
              </div>
            </Card>)}
      </div>
    </div>;
}